﻿export class room_passengers_type_combination_passenger {
    public age_category: string | null = null;
    public index: number | null = null;
}